<template>
    <div class="activate-container">
        <rcTable :tableAttr="tableAttr"
                 :checkPms="hasPermission('CB1720')"
                 ref="rcTable">
            <!-- btn 操作区 -->
            <Button @click="refresh"
                    v-if="hasPermission('CB1720')"
                    slot="tootipL">
                <i class="icon-refresh-o-2"></i>
            </Button>
            <create-btn v-if="update"
                        slot="tootipL" />
        </rcTable>
        <!-- 存储变配 -->
        <storage-change ref="storageChange"
                        @refresh="refresh" />
        <!--倒计时-->
        <countdown ref="countdown"
                   :txt="$t('退订成功')"
                   :jumpTxt="$t('我的订单')"
                   jumpLink="/mgt/order">
        </countdown>
        <ChangeRecord ref="changeRecord" />
        <Spin v-if="btnLoading"
              fix>
            <Icon type="ios-loading"
                  :size='24'
                  class="demo-spin-icon-load"></Icon>
            <div>{{$t('退订中')}}</div>
        </Spin>
        <!-- 挂载 -->
        <StorageMount ref="storageMount"
                      @refresh="refresh" />
        <!-- 卸载 -->
        <StorageUninstall ref="storageUninstall"
                          @refresh="refresh" />
    </div>
</template>

<script>
import API from '@/service/api.js'
import rcTable from '@c/basic/rcTable'
import dropdownlist from '@c/basic/dropdownlist'
import createBtn from './createhpcbtn.vue'
import storageChange from './storagechange.vue'
import ChangeRecord from './changerecord.vue'
import { copyTextToClipboard } from '@/service/utils'
import countdown from '@c/basic/countdown'
import StorageMount from '@/views/console/hpcdetail/components/editmodal.vue'
import StorageUninstall from '@/views/console/hpc/components/storageUninstall.vue'

export default {
    name: 'HpcActive',
    components: {
        rcTable,
        createBtn,
        storageChange,
        ChangeRecord,
        countdown,
        StorageMount,
        StorageUninstall
    },
    computed: {
        parentSid () {
            return this.$store.state.user.currentUser.info.parentSid || null
        },
        isFreezeStatus () {
            // 用户是否冻结
            return this.$store.state.user.currentUser.isFreezeStatus
        },
        isHpcFreezeStatus () {
            // hpc共享是否冻结
            return this.$store.state.user.currentUser.isHpcFreezeStatus
        },
        isHpcSaasFreezeStatus () {
            // hpc-ssa共享是否冻结
            return this.$store.state.user.currentUser.isHpcSaasFreezeStatus
        },
        isHpcDrpFreezeStatus () {
            // hpc专属是否冻结
            return this.$store.state.user.currentUser.isHpcDrpFreezeStatus
        },
        // 是否实名认证和企业认证
        isAuthentStatus () {
            const userAuth = this.$store.state.user.currentUser.info.authentStatus
            const comAuth = this.$store.state.user.currentOrg.certificationStatus
            // const flag = this.authType === 'company' ? comAuth !== 'authSucceed' : userAuth !== 'authSucceed'
            return !(comAuth === 'authSucceed' || userAuth === 'authSucceed')
        }
    },
    data () {
        const languageType = this.$store.state.app.appConfig.language
        return {
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.ALL_HPC)
                },
                searchColumns: [
                    {
                        key: 'clusterName',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'clusterType',
                        title: this.$t('集群类型'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [{
                            value: 'SAASShare',
                            name: this.$t('共享')
                        }, {
                            value: 'SAASPrivate',
                            name: this.$t('普通自定义专属')
                        }, {
                            value: 'PreSAASPrivate',
                            name: this.$t('标准专属')
                        }, {
                            value: 'AdSAASPrivate',
                            name: this.$t('高级自定义专属')
                        }]
                    },
                    {
                        key: 'status',
                        title: this.$t('状态'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [
                            { value: 'apply', name: this.$t('申请中') },
                            { value: 'configing', name: this.$t('配置中') },
                            { value: 'available', name: this.$t('运行中') },
                            { value: 'expired', name: this.$t('已过期') },
                            { value: 'frozen', name: this.$t('已冻结') },
                            { value: 'rejected', name: this.$t('已拒绝') },
                            { value: 'configed', name: this.$t('配置完成') },
                            { value: 'unsubscribing', name: this.$t('退订中') },
                            // { value: 'unsubscribed', name: this.$t('已退订') },
                            // { value: 'unsubscribe_error', name: this.$t('退订失败') },
                            // { value: 'deleting', name: this.$t('删除中') },
                            // { value: 'deleted', name: this.$t('已删除') },
                            { value: 'upgrading', name: this.$t('扩容中') }
                        ]
                    }
                ],
                columnsChooseShow: true,
                searchShow: true,
                referenceVal: 1420,
                columns: [
                    {
                        title: this.$t('名称') + '/ID',
                        key: 'clusterName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            const { resourceId, clusterId, productType, clusterName } = params.row
                            let style = { width: '96%', paddingTop: '5px', height: '50px' }
                            if (!resourceId) {
                                style = { width: '96%', display: 'flex', height: '50px', alignItems: 'center' }
                            }
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h('div', {
                                    class: 'ellipsis',
                                    style
                                }, [
                                    clusterName && h('div',
                                        {
                                            class: 'ellipsis name',
                                            attrs: {
                                                title: this.$t(clusterName) || '--'
                                            }
                                        },
                                        [
                                            h('a', {
                                                on: {
                                                    click: () => {
                                                        this.hasPermission('CB1721') && this.goDetail(clusterId, productType)
                                                    }
                                                }
                                            }, this.$t(clusterName) || '--')
                                        ]

                                    ),
                                    resourceId && h(
                                        'div',
                                        {
                                            class: 'ellipsis',
                                            style: { width: '90%', color: '#666', paddingBottom: '5px' },
                                            attrs: {
                                                title: resourceId
                                            }
                                        },
                                        resourceId
                                    ),
                                    resourceId && h(
                                        'Tooltip',
                                        {
                                            class: 'rc-tips copyId',
                                            style: { position: 'absolute', left: '90%', top: '26px', width: '15px' },
                                            props: {
                                                transfer: true,
                                                placement: 'top',
                                                theme: 'light',
                                                content: this.$t('复制ID')
                                            }
                                        },
                                        [
                                            h('Icon', {
                                                class: 'copy-icon',
                                                style: { color: '#1f68b3', 'font-size': '14px' },
                                                props: {
                                                    type: 'ios-browsers-outline'
                                                },
                                                on: {
                                                    click: () =>
                                                        copyTextToClipboard(resourceId, () => {
                                                            this.$Message.success(this.$t('复制成功'))
                                                        })
                                                }
                                            })
                                        ]
                                    )
                                ])
                            ])
                        }
                    },
                    {
                        title: this.$t('集群类型'),
                        key: 'productType',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t('集群类型')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [
                                    h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            color: '#2d8cf0',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('p', this.$t('共享：共享资源池，采用按需计费模式。')),
                                        h('p', this.$t('普通/高级自定义专属：按需自主，根据实际需要，在购买时选择不同数量的计算节点组成集群，')),
                                        h('p', this.$t('普通专属不支持文件系统的挂载卸载，高级专属支持标准文件系统的挂载卸载能力。')),
                                        h('p', this.$t('标准专属：集群的节点规格是固定的，部署效率优于自定义专属集群。'))
                                    ])
                                ])
                            ])
                        },
                        render: (h, params) => {
                            const { clusterType } = params.row
                            const clusterTypeMaps = {
                                SAASShare: '共享',
                                SAASPrivate: '普通自定义专属',
                                PreSAASPrivate: '标准专属',
                                AdSAASPrivate: '高级自定义专属'
                            }
                            const productTypeName = clusterTypeMaps[clusterType] || '--'
                            return h('span', { attrs: { title: this.$t(productTypeName) } }, this.$t(productTypeName))
                        }
                    },

                    {
                        title: this.$t('存储类型'),
                        key: 'storageType',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        filterMultiple: false,
                        width: 90,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', this.$t('存储类型')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [
                                    h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            color: '#2d8cf0',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('p', this.$t('共享：针对共享资源池，采用共享文件系统。')),
                                        h('p', this.$t('混合：针对共享资源池，同时采用共享文件系统及专属文件系统。')),
                                        h('p', this.$t('专属：采用专属文件文件系统。'))
                                    ])
                                ])
                            ])
                        },
                        render: (h, params) => {
                            const { storageType } = params.row
                            const storageTypeNameMaps = {
                                1: '专属存储',
                                2: '共享存储',
                                3: '混合存储'
                            }
                            return h('span', { attrs: { title: this.$t(storageTypeNameMaps[storageType] || '--') } }, this.$t(storageTypeNameMaps[storageType] || '--'))
                        }
                    },
                    {
                        title: this.$t('绑定存储'),
                        key: 'shareList',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        filterMultiple: false,
                        width: 90,
                        render: (h, params) => {
                            const { shareList } = params.row
                            let arr = []
                            if (Array.isArray(shareList) && shareList.length) {
                                arr = shareList.map(item => {
                                    return h('a',
                                        {
                                            attrs: {
                                                class: 'rc-ellipsis', title: this.$t(item.shareName)
                                            },
                                            style: 'display: block;',
                                            on: {
                                                click: () => {
                                                    this.$router.push({
                                                        path: '/mgt/scalableFile',
                                                        query: {
                                                            name: item.shareName
                                                        }
                                                    })
                                                }
                                            }
                                        }, this.$t(item.shareName))
                                })
                            } else {
                                arr = [
                                    h('span', '--')
                                ]
                            }
                            return h('div', { attrs: { class: 'rc-ellipsis' } }, arr)
                        }
                    },
                    {
                        title: this.$t('所属资源池'),
                        key: 'poolName',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            const { poolName } = params.row
                            return h('span', { attrs: { title: poolName || '--' } }, this.$t(poolName) || '--')
                        }
                    },
                    {
                        title: this.$t('状态'),
                        key: 'status',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        filterMultiple: false,
                        width: 100,
                        render: (h, params) => {
                            const { status, frozenTime, orderHanlderMsg } = params.row
                            const statusNameMaps = {
                                apply: '申请中',
                                configing: '配置中',
                                available: '运行中',
                                soonExpire: '运行中',
                                expired: '已过期',
                                frozen: '已冻结',
                                rejected: '已拒绝',
                                unsubscribing: '退订中',
                                unsubscribed: '已退订',
                                configed: '配置完成',
                                deleted: '已删除',
                                deleting: '删除中',
                                unsubscribe_error: '退订失败',
                                upgrading: '扩容中'
                            }
                            return ['frozen', 'rejected'].includes(status) ? h('syncpoptip', {
                                props: {
                                    value: this.$t(statusNameMaps[status]),
                                    errMsg: this.$t(status === 'frozen' ? `冻结时间：${frozenTime || '--'}` : `拒绝原因：${orderHanlderMsg || '--'}`),
                                    isStatic: true
                                }
                            }) : h('statusview', {
                                props: {
                                    state: status,
                                    stateName: this.$t(statusNameMaps[status] || '未知')
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('计费模式'),
                        key: 'chargeType',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 80,
                        render: (h, params) => {
                            const chargeTypeName = {
                                PostPaid: this.$t('按量计费'),
                                PrePaid: this.$t('包年包月'),
                                None: this.$t('不计费')
                            }
                            return h('span', { attrs: { title: chargeTypeName[params.row.chargeType] } }, chargeTypeName[params.row.chargeType])
                        }
                    },
                    {
                        title: this.$i18n.t('开始时间'),
                        key: 'startTime',
                        columnShow: true,
                        sortable: 'custom',
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 140,
                        render: (h, params) => {
                            return h('span', params.row.startTime || '--')
                        }
                    },
                    {
                        title: this.$i18n.t('结束时间'),
                        key: 'endTime',
                        columnShow: true,
                        sortable: 'custom',
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 140,
                        render: (h, params) => {
                            return h('span', params.row.endTime || '--')
                        }
                    },
                    {
                        title: this.$t('操作'),
                        width: languageType === 'en-US' ? 220 : 210,
                        resizable: true,
                        fixed: 'right',
                        render: (h, params) => {
                            const { status, shareList, productType } = params.row
                            const notVir = shareList && shareList.find(item => !item.isVirtual)
                            const hasConsolePer = ['available', 'expired', 'soonExpire', 'upgrading'].includes(status)
                            const hasControlPer = this.hasPermission('CB1701')
                            const hasSSHPer = this.hasPermission('CB1702')
                            const hasChangePer = ['available', 'expired', 'soonExpire'].includes(status) && notVir // 变更
                            const hasRenewUnsubPer = ['available', 'expired', 'frozen', 'soonExpire'].includes(status) // 续订，退订
                            const hasBindStorage = shareList && shareList.length // 有绑定存储数据, 才能变更
                            const hasPerCode = this.hasPermission('CB1704') || this.hasPermission('CB1705') || this.hasPermission('CB1706')
                            const hasChangeRecord = productType === 'HPC-DRP' && this.hasPermission('CB1715')
                            const downListHasPer = ((hasChangePer && hasBindStorage) || hasRenewUnsubPer || hasChangeRecord) && hasPerCode
                            let arr = []
                            if (productType === 'HPC-DRP') {
                                const a = [
                                    h('a', { class: { 'disabled-per': this.isAuthentStatus || !hasConsolePer || !hasControlPer }, on: { click: () => !this.isAuthentStatus && hasConsolePer && hasControlPer && this.ccPortal(params.row) } }, this.$t('控制台')),
                                    h('a', { class: { 'disabled-per': this.isAuthentStatus || !hasConsolePer || !hasSSHPer }, on: { click: () => !this.isAuthentStatus && hasConsolePer && hasSSHPer && this.webSSH(params.row) } }, this.$t('登录节点'))
                                ]
                                arr.push(...a)
                            } else {
                                let freezeStatus = false
                                if (params.row.clusterType === 'SAASShare' && params.row.productType === 'HPC') {
                                    freezeStatus = this.isHpcFreezeStatus
                                } else if (params.row.clusterType === 'SAASShare' && params.row.productType === 'HPC-SAAS') {
                                    freezeStatus = this.isHpcSaasFreezeStatus
                                } else {
                                    freezeStatus = this.isHpcDrpFreezeStatus
                                }
                                const b = [
                                    h('a', {
                                        class: { 'disabled-per': this.isAuthentStatus || (this.isFreezeStatus || freezeStatus) || !hasConsolePer || !hasControlPer }, on: { click: () => !this.isAuthentStatus && !this.isFreezeStatus && !freezeStatus && hasConsolePer && hasControlPer && this.ccPortal(params.row) }
                                    }, this.$t('控制台')),
                                    h('a', { class: { 'disabled-per': this.isAuthentStatus || (this.isFreezeStatus || freezeStatus) || !hasConsolePer || !hasSSHPer }, on: { click: () => !this.isAuthentStatus && !this.isFreezeStatus && !freezeStatus && hasConsolePer && hasSSHPer && this.webSSH(params.row) } }, this.$t('登录节点'))
                                ]
                                arr.push(...b)
                            }
                            let configBtnDisabled = true
                            const configBtn = JSON.parse(this.configBtn(params.row))
                            for (const i in configBtn) {
                                if (!configBtn[i].disabled) {
                                    configBtnDisabled = false
                                    break
                                }
                            }
                            arr.push(h(dropdownlist, {
                                class: { 'disabled-per': !downListHasPer || configBtnDisabled },
                                props: {
                                    operateConfig: this.configBtn(params.row)
                                },
                                style: 'cursor:pointer; display:inline-block; margin-left: 5px;',
                                on: { event: (type) => { this.operate(type, params.row) } }
                            }))
                            const onlyDelete = ['rejected'].includes(status)
                            const deleteHasPer = this.hasPermission('CB1707')
                            if (onlyDelete) {
                                arr = [
                                    h('a', { class: { 'disabled-per': !deleteHasPer }, on: { click: () => deleteHasPer && this.deleteHPC(params.row) } }, this.$t('删除'))
                                ]
                            }
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, arr)
                        }
                    }
                ]
            },
            update: true, // 刷新子组件
            btnLoading: false,
            timer: null
        }
    },
    methods: {
        // 刷新
        refresh () {
            this.$refs.rcTable.refreshTable()
            // 刷新子组件
            this.update = false
            this.$nextTick(() => {
                this.update = true
            })
        },
        // 控制台
        ccPortal ({ clusterId, ccpVersion }) {
            const hasSubPermissions = this.hasSubPermissionsFun(clusterId)
            if (hasSubPermissions instanceof Object) {
                hasSubPermissions.then(res => {
                    if (res) {
                        const { href } = this.$router.resolve({
                            name: 'hpcconsole',
                            query: {
                                clusterId
                            }
                        })
                        window.open(href, '_blank')
                        this.addLog('控制台', 'systemConsole', '/hpcconsole')
                    } else {
                        this.$Message.error(this.$t('该操作无权限，请刷新页面后查看该资源是否存在，或者账号是否实名认证。'))
                    }
                })
            } else {
                this.$Message.error(this.$t('该操作无权限，请刷新页面后查看该资源是否存在，或者账号是否实名认证。'))
            }
        },
        // 检查用户是否关联了HPC集群
        hasSubPermissionsFun (clusterId) {
            return clusterId ? this.axios.get(this.urlFormat(API.HPC_CLUSTER_CHECK + '?clusterId=' + clusterId, false)) : false
        },
        // 去操作页
        webSSH ({ clusterId }) {
            this.axios.get(this.urlFormat(API.GET_HPCLOGINNODE, false) + `?clusterId=${clusterId}`).then(res => {
                if (res && res.code) {
                    console.log('错误')
                } else {
                    this.addLog('SSH控制台', 'sshConsole', '/webssh')
                    this.$store.commit('setSSHToken', res)
                    const routeData = this.$router.resolve({
                        path: '/webssh',
                        query: {
                            name: 'SSH控制台',
                            id: null,
                            opType: 'SSH',
                            resType: 'SSH控制台'
                        }
                    })
                    window.open(routeData.href, '_blank')
                }
            })
        },
        // 生成更多按钮
        configBtn (row) {
            // HPC专属资源池都走变配界面
            // HPC共享资源池分专属文件系统和共享文件系统,专属文件系统(isVirtual===true)只可以变配(弹窗), 共享文件系统(isVirtual===false)不能变配
            const { productType, status, shareList, clusterType } = row
            const notVir = shareList && shareList.find(item => !item.isVirtual)
            const isClusterDefaultList = shareList && shareList.filter(item => item.isClusterDefault)
            let freezeStatus = false
            if (row.clusterType === 'SAASShare' && row.productType === 'HPC') {
                freezeStatus = this.isHpcFreezeStatus
            } else if (row.clusterType === 'SAASShare' && row.productType === 'HPC-SAAS') {
                freezeStatus = this.isHpcSaasFreezeStatus
            } else {
                freezeStatus = this.isHpcDrpFreezeStatus
            }
            const hasChangePer = !this.isFreezeStatus && !freezeStatus && ['available', 'expired', 'soonExpire'].includes(status) && (notVir || clusterType !== 'SAASShare')
            const hasRenewUnsubPer = !this.isFreezeStatus && !freezeStatus && ['available', 'expired', 'frozen', 'soonExpire'].includes(status)
            const hasBindStorage = shareList && shareList.length // 有绑定存储数据
            const hasUnsubPer = this.parentSid === null // 租户才有权限
            const btnConfig = [
                {
                    btnName: this.$t('存储管理'),
                    display: true,
                    children: [
                        { value: 'changeSFS', btnName: this.$t('存储变配'), display: true, disabled: !hasChangePer || !this.hasPermission('CB1705') || (clusterType === 'PreSAASPrivate' && isClusterDefaultList.length === shareList.length) || !hasBindStorage || (shareList.length - isClusterDefaultList.length === 0) },
                        { value: 'storageMount', btnName: this.$t('存储挂载'), display: true, disabled: !['PreSAASPrivate', 'AdSAASPrivate'].includes(clusterType) || !this.hasPermission('CB1717') || !['available', 'soonExpire', 'expired'].includes(status), tips: clusterType === 'SAASPrivate' && this.$t('普通自定义专属，存储挂载为禁用状态!') },
                        { value: 'storageUninstall', btnName: this.$t('存储卸载'), display: true, disabled: !['PreSAASPrivate', 'AdSAASPrivate'].includes(clusterType) || !this.hasPermission('CB1718') || !['available', 'soonExpire', 'unInstall_error', 'frozen', 'expired'].includes(status), tips: clusterType === 'SAASPrivate' && this.$t('普通自定义专属，存储卸载为禁用状态!') }
                    ]
                },
                { value: 'renew', btnName: this.$t('服务续订'), display: (productType !== 'HPC' && productType !== 'HPC-SAAS'), disabled: !hasUnsubPer || !hasRenewUnsubPer || !this.hasPermission('CB1706') },
                { value: 'unsubscribe', btnName: this.$t('服务退订'), display: true, disabled: !hasRenewUnsubPer || !hasUnsubPer || this.btnLoading || !this.hasPermission('CB1704') },
                { value: 'changeRecord', btnName: this.$t('变更记录'), display: productType === 'HPC-DRP', disabled: !this.hasPermission('CB1715') }
            ]
            return JSON.stringify(btnConfig)
        },
        // 存储挂载
        storageMount ({ resourceId, clusterId }) {
            this.$refs.storageMount.openModal(resourceId, clusterId)
        },
        // 存储卸载
        storageUninstall (row) {
            const params = {
                linksNotLike: 'home'
            }
            this.$refs.storageUninstall.open(row, params)
        },
        // 添加操作日志
        addLog (consoleName, consoleCode, consoleUrl) {
            const params = {
                userSid: this.$store.state.user.currentUser.info.userSid,
                consoleName: consoleName,
                consoleCode: consoleCode,
                consoleUrl: consoleUrl
            }
            this.axios.post(this.urlFormat(API.POST_USERS_ADD_LOG, true), params)
        },
        // 更多按钮事件分发
        operate (operateType, row) {
            if (this.timer) {
                return
            }
            this.timer = setTimeout(() => {
                switch (operateType) {
                    case 'changeSFS':
                        this.changeSFS(row)
                        break
                    case 'renew':
                        this.renew(row)
                        break
                    case 'unsubscribe':
                        this.unsubscribe(row)
                        break
                    case 'changeRecord':
                        this.changeRecord(row)
                        break
                    case 'storageMount':
                        this.storageMount(row)
                        break
                    case 'storageUninstall':
                        this.storageUninstall(row)
                }
                this.timer = null
            }, 500)
        },
        // 删除
        deleteHPC ({ clusterId }) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('确认要删除该数据吗') + '？',
                onOk: () => {
                    this.axios.delete(`${this.urlFormat(API.ALL_HPC)}/${clusterId}`).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        // 变更
        changeSFS ({ clusterType, shareList, clusterId }) {
            const hasSubPermissions = this.hasSubPermissionsFun(clusterId)
            if (hasSubPermissions) {
                this.$refs.storageChange && this.$refs.storageChange.openModal(shareList, clusterType)
            } else {
                this.$Message.error(this.$t('该操作无权限，请刷新页面后查看该资源是否存在。'))
            }
        },
        // 变更记录
        changeRecord (row) {
            this.$refs.changeRecord.open(row)
        },
        // 续订
        renew ({ id, productType, productName, name, clusterId }) {
            const hasSubPermissions = this.hasSubPermissionsFun(clusterId)
            if (hasSubPermissions) {
                // 专属
                sessionStorage.setItem('renewList', JSON.stringify([{ id: String(id), productType: productType, name: name || productName }]))
                this.$router.push({
                    name: 'renewdetail',
                    query: { type: 'batch', productType: productType, name: productName }
                })
            } else {
                this.$Message.error(this.$t('该操作无权限，请刷新页面后查看该资源是否存在。'))
            }
        },
        // 退订
        unsubscribe (row) {
            const { id, productType, status, clusterId } = row
            const hasSubPermissions = this.hasSubPermissionsFun(clusterId)
            if (hasSubPermissions) {
                if (productType === 'HPC' || productType === 'HPC-SAAS') {
                    // 共享
                    this.unsubscribeClick(row)
                } else {
                    // 专属
                    this.$router.push({
                        name: 'unsubscribe',
                        query: { id: id, productType: productType, status: status }
                    })
                }
            } else {
                this.$Message.error(this.$t('该操作无权限，请刷新页面后查看该资源是否存在。'))
            }
        },
        unsubscribeClick (row) {
            // let title = null
            // let content = null
            // if (row.status === 'normal1') {
            //     title = '服务退订'
            //     content = '存在运行中的作业，无法退订服务，请手动删除'
            // } else {
            //     title = '确定要继续执行该操作吗?'
            //     content = '如果存在运行中的作业则无法退订，请手动删除后再进行此操作。'
            // }
            // 服务退
            this.$Modal.confirm({
                title: this.$t('确定要继续执行该操作吗?'),
                content: this.$t('如果存在运行中的作业则无法退订，请手动删除后再进行此操作。'),
                onOk: () => {
                    this.btnLoading = true
                    this.axios.delete(this.urlFormat(API.DELETE_SERVICE_UNSUBSCRIBE_ID, false, [row.id]), { headers: { showMsg: false } }).then(res => {
                        this.btnLoading = false
                        if (res.status) {
                            this.$refs.countdown.goChoicePeople(null)
                        } else {
                            res.message && this.$Message.error({ content: res.message, duration: 5 })
                        }
                    }).catch(e => {
                        this.btnLoading = false
                    })
                }
            })
        },
        async goDetail (clusterId, productType) {
            await this.getUserInfoByToken()
            await this.$router.push(`/mgt/hpc/${clusterId}?productType=${productType}`)
        },
        async getUserInfoByToken () {
            const params = { moduleType: 'console' }
            const result = await this.axios.get(this.urlFormat(API.TOKEN, true), { params })
            this.$store.commit('setUserData', result)
        }
    }
}
</script>

<style lang="less">
.activate-container {
    .dropdownlist.disabled-per {
        a {
            color: #ccc;
        }
    }
}
</style>
